import React from 'react';

export default function TelephoneNumber() {
  return (
    <a href="tel:+12505898555" className="telephone-number">
      1-250-589-8555
    </a>
  );
}
